<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Rewards">
        <template #header>
            Reward Claimed
        </template>
        <div class="flex min-h-screen w-screen bg-gray-900">
            <div class="flex flex-col w-4/5 lg:w-1/4 mx-auto justify-center h-full items-center my-auto">
                <img :src="'/images/racingleague/racingleaguebase.png'" alt="">
                <div class="w-full text-white font-medium text-lg text-center mt-8">
                    <div class="border flex border-racing-league-red/50 p-3 rounded-md shadow-lg h-40 bg-gray-800/60 backdrop-blur text-center">
                        <p class="my-auto mx-auto">
                            User has successfully redeemed '{{ reward.named }}'
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
export default {
  props: {
    reward: Object,
  },
};
</script>
